import { api } from '../utils/api'

import type { Link, LinkTypeParam } from '../types'
import { useInfiniteLoading } from './useInfiniteLoading'

type Args = {
  type?: LinkTypeParam
  query?: string | null
  slug?: string | null
  parent?: boolean | null
}

const fetchLinks = async (
  { pageParam }: { pageParam: number },
  { type, query, slug, parent }: Args
) => {
  const resp = await api.get('/links', {
    params: {
      type,
      q: query,
      slug,
      parent,
      page: pageParam,
    },
  })
  return {
    data: resp.data.data ?? [],
    totalCount: resp.data.totalCount ?? 0,
  }
}

export const useLinks = (args: Args) => {
  return useInfiniteLoading<Link>({
    queryKey: ['all-links', args.type, args.query, args.slug, args.parent],
    queryFn: (p) => fetchLinks(p, args),
  })
}
